<template>
  <a-drawer
    width="600"
    placement="right"
    :visible="visible"
    @close="onClose"
  >

    <div class="part-head">
      <p class="part-title">设备列表</p>
    </div>

    <!-- 列表 -->
    <a-table
      :columns="columns"
      :dataSource="app"
      :pagination="rechargePagination"
      :loading="changeLoading"
      :rowKey="record=>record.deviceSn"
    >
      <template slot="isWriteOff" slot-scope="text, record">
        <span>{{record.isWriteOff?"是":"否"}}</span>
      </template>
    </a-table>
  </a-drawer>
</template>


<script>
import columns from "./tableConfig";
export default {
  name: "DetailsTerminalDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    app: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      appInfo: {},
      columns,
      changeLoading: false,
      rechargeData: [],
      rechargePagination: {
        current: 1,
        pageSize: 40,
        total: 0
      }
    }
  },
  watch: {
    app: function(data) {
      if (data && this.visible) {
        this.appInfo = { ...data }
      }
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
</style>
